// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.days-bar {
  position: relative;
  width: 100%;
}
.days-bar .right {
  right: 0;
}
.days-bar .left {
  left: 0;
}
.days-bar ion-button {
  width: 50px;
  height: 100%;
  margin: auto 0 auto 0;
}
.days-bar ion-segment {
  margin-left: 50px;
  width: calc(100% - 100px);
}
.days-bar ion-segment ion-segment-button {
  min-width: 0;
}
.days-bar ion-segment ion-segment-button ion-label {
  text-decoration: none;
}
.days-bar .day-ion-segment-button-today {
  text-decoration: underline;
}
.days-bar .day-ion-segment-button {
  min-height: 70px;
  line-height: 2rem !important;
}

.today-button {
  padding: 3px !important;
}
.today-button img {
  max-height: 100%;
}

.loading-spinner {
  height: 100px !important;
}

.mine {
  margin: 0 10px 0 10px;
  border-bottom: var(--ion-color-first-category) thin solid;
  color: var(--ion-color-first-category) !important;
}

.not-mine {
  margin: 0 10px 0 10px;
  border-bottom: var(--ion-color-third-category) thin solid;
  color: var(--ion-color-third-category) !important;
}

.space {
  height: 60px;
}

ion-title {
  padding-left: 5px;
}

.deliveryCount {
  font-size: 14px;
}

.toggle {
  font-size: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/delivery/delivery-list/delivery-list.page.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,WAAA;AAAJ;AAEI;EACI,QAAA;AAAR;AAGI;EACI,OAAA;AADR;AAII;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AAFR;AAKI;EACI,iBAAA;EACA,yBAAA;AAHR;AAKQ;EACI,YAAA;AAHZ;AAKY;EACI,qBAAA;AAHhB;AAQI;EACI,0BAAA;AANR;AASI;EACI,gBAAA;EACA,4BAAA;AAPR;;AAaA;EACI,uBAAA;AAVJ;AAYI;EACI,gBAAA;AAVR;;AAcA;EACI,wBAAA;AAXJ;;AAcA;EACI,qBAAA;EACA,yDAAA;EACA,iDAAA;AAXJ;;AAcA;EACI,qBAAA;EACA,yDAAA;EACA,iDAAA;AAXJ;;AAcA;EACI,YAAA;AAXJ;;AAcA;EACI,iBAAA;AAXJ;;AAcA;EACI,eAAA;AAXJ;;AAcA;EACI,eAAA;AAXJ","sourcesContent":["\r\n.days-bar {\r\n    position: relative;\r\n    width: 100%;\r\n\r\n    .right {\r\n        right: 0;\r\n    }\r\n\r\n    .left {\r\n        left: 0;\r\n    }\r\n\r\n    ion-button {\r\n        width: 50px;\r\n        height: 100%;\r\n        margin: auto 0 auto 0;\r\n    }\r\n\r\n    ion-segment {\r\n        margin-left: 50px;\r\n        width: calc(100% - 100px);\r\n\r\n        ion-segment-button {\r\n            min-width: 0;\r\n\r\n            ion-label {\r\n                text-decoration: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    .day-ion-segment-button-today {\r\n        text-decoration: underline;\r\n    }\r\n\r\n    .day-ion-segment-button {\r\n        min-height: 70px;\r\n        line-height: 2rem !important;\r\n    }\r\n}\r\n\r\n\r\n\r\n.today-button {\r\n    padding: 3px !important;\r\n\r\n    img {\r\n        max-height: 100%;\r\n    }\r\n}\r\n\r\n.loading-spinner {\r\n    height: 100px !important;\r\n}\r\n\r\n.mine {\r\n    margin: 0 10px 0 10px;\r\n    border-bottom: var(--ion-color-first-category) thin solid;\r\n    color: var(--ion-color-first-category) !important;\r\n}\r\n\r\n.not-mine {\r\n    margin: 0 10px 0 10px;\r\n    border-bottom: var(--ion-color-third-category) thin solid;\r\n    color: var(--ion-color-third-category) !important;\r\n}\r\n\r\n.space {\r\n    height: 60px;\r\n}\r\n\r\nion-title {\r\n    padding-left: 5px;\r\n}\r\n\r\n.deliveryCount {\r\n    font-size: 14px;\r\n}\r\n\r\n.toggle {\r\n    font-size: 28px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
